import React, { useState, useEffect } from "react";

type AppImageProps = React.ImgHTMLAttributes<HTMLImageElement> & {
  fallbackSrc?: string;
};

const AppImage: React.FC<AppImageProps> = ({
  src,
  fallbackSrc = "/assets/images/no_image.png",
  ...rest
}) => {
  const [currentSrc, setCurrentSrc] = useState<string>(src || fallbackSrc);

  // If the src prop changes, update the image
  useEffect(() => {
    setCurrentSrc(src || fallbackSrc);
  }, [src, fallbackSrc]);

  const handleError = () => {
    // Only switch to fallback once, avoid infinite loop
    if (currentSrc !== fallbackSrc) {
      setCurrentSrc(fallbackSrc);
    }
  };

  return <img src={currentSrc} onError={handleError} {...rest} />;
};

export default AppImage;
